/** @jsxRuntime classic */
/** @jsx jsx */
import moment from "moment";
import { jsx } from "@emotion/core";
import { RRule, rrulestr } from "rrule";
import momentTimezone from 'moment-timezone';
import { getBackgroundImages } from "./common";
import _ from 'lodash';
import linkifyHtml from "linkify-html";
import DOMPurify from 'isomorphic-dompurify';
import MarkdownIt from 'markdown-it';
import { convertToRaw, Modifier, SelectionState } from "draft-js";
import { stateToHTML } from "draft-js-export-html";

const markdown = new MarkdownIt({ html: true });

export const caseInsensitiveSortBy = (array, path, order = 'asc') => {
  return _.orderBy(array, [item => removeHtmlMarkups(_.get(item, path, "")?.toLowerCase() ?? "")], [order]);
};

export const dateToFromNowDaily = ( myDate , color , theme) => {
  return myDate == moment().format('MM/DD/YYYY') 
                    ? 
                    moment( myDate ).format(`[<span class="ac-today" style="color: ${theme == "dark" ? color: color}">Today</span> <span class="ac-date" style="color: ${theme == "dark" ? "white" :""}">]D MMMM[</span> <span classe="ac-day" style="color: ${theme == "dark" ? "white" :""}">]dddd[</span>]`) 
                    : 
                    moment( myDate ).format(`[<span class="ac-date" style="color: ${theme == "dark" ? "white" :""}">]D MMMM[</span> <span class="ac-day" style="color: ${theme == "dark" ? "white" :""}">]dddd[</span>]`);
}

export const focusTimerFormatStatic = ( time, activeColor = "#fff" ) => {
  return `<span style="color: ${time[0] != '' ? activeColor : ''}" class="ft-time ${time[0] != '' ? 'active' : ''}">${time[0] != '' ? time[0] : '00'} : </span><span style="color: ${time[1] != '' ? activeColor : ''}" class="ft-time  ${time[1] != '' ? 'active' : ''}">${time[1] != '' ? time[1] : '00'} : </span><span  style="color: ${time[2] != '' ? activeColor : ''}" class="ft-time  ${time[2] != '' ? 'active' : ''}">${time[2] != '' ? time[2] : '00'}</span>`;
}

export const focusTimerFormat = ( time, activeColor = "#fff", h = 'HH', m = 'mm', s = 'ss' ) => {
    return moment.utc(time * 1000).format(`[<span style="color: ${time >= 3600 ? activeColor : ''}" class="ft-time ${time >= 3600 ? 'active' : ''}">]${h}[ : </span><span style="color: ${time >= 60 ? activeColor : ''}" class="ft-time  ${time >= 60 ? 'active' : ''}">]${m}[ : </span><span  style="color: ${time > 0 ? activeColor : ''}" class="ft-time  ${time > 0 ? 'active' : ''}">]${s}[</span>]`)
}

export const focusTimerFormatBreak = ( time, activeColor = "#fff" ) => {
    return moment.utc(time * 1000).format(`[<span style="color: ${time >= 3600 ? activeColor : ''}" class="ft-time ${time >= 3600 ? 'active' : ''}">]HH[ : </span><span style="color: ${time >= 60 ? activeColor : ''}" class="ft-time  ${time >= 60 ? 'active' : ''}">]mm[ : </span><span  style="color: ${time > 0 ? activeColor : ''}" class="ft-time  ${time > 0 ? 'active' : ''}">]ss[</span>]`)
}

export const focusTimerFormatV2 = ( time ) => {
    return moment.utc(time * 1000).format(`[<span class="ft-time time]HH[">]H [hr][ <span class="${time % 3600 === 0 ? 'time00' : ''}">:</span> </span><span class="ft-time time]mm[">]m [min][ <span class="${(time % 3600) % 60 === 0 ? 'time00' : ''}">:</span> </span><span class="ft-time time]ss[">]s [sec][</span>]`)
}

export const focusTimerFormatV3 = ( time, showSec = false ) => {
  return time < 60 && showSec ? moment.utc(time * 1000).format(`[<span class="ft-time ${showSec ? 'timeshow' : ''} time]ss[">]s [sec][</span>]`) : moment.utc(time * 1000).format(`[<span class="ft-time time]HH[">]H [${time / 3600 >= 2 ? 'hrs' : 'hr'}][ </span><span class="ft-time min time]mm[">]m [${time / 60 >= 2 ? 'mins' : 'min'}][</span>]`)
}

export const focusTimerFormatV4 = ( time ) => {
  return moment.utc(time * 1000).format(`[<span class="ft-time time]HH[">]H [${time / 3600 >= 2 ? 'hours' : 'hour'}][ </span><span class="ft-time min time]mm[">]m [${time / 60 >= 2 ? 'minutes' : 'minute'}][</span>]`)
}

export const focusTimerFormatV5 = ( time, showSec = false ) => {
  return time < 60 && showSec ? moment.utc(time * 1000).format(`[<span class="ft-time ${showSec ? 'timeshow' : ''} time]ss[">]s [seconds][</span>]`) : moment.utc(time * 1000).format(`[<span class="ft-time time]HH[">]H [${time / 3600 >= 2 ? 'hours' : 'hour'}][ </span><span class="ft-time hidemin min time]mm[">]m [${time / 60 >= 2 ? 'minutes' : 'minutes'}][</span>]`)
}

export const format = (date, format) => {
  return moment(date).format(format);
}

export const calendarFormat = (date) => {
  return isValidDate(date) ? moment(date).calendar(null, {
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      lastDay: '[Yesterday]',
      nextWeek: 'D MMM YYYY',
      lastWeek: 'D MMM YYYY',
      sameElse: 'D MMM YYYY'
  }) : 'No Date';
}

export const calendarFormat2 = (date) => {
  return isValidDate(date) ? moment(date).calendar(null, {
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      lastDay: '[Yesterday]',
      nextWeek: 'dddd',
      lastWeek: 'dddd',
      sameElse: 'dddd'
  }) : 'No Date';
}

export const calcRecentOverDueDate = (task) => {
  let date = task?.date;
  if(task?.repeat?.rule){
    const taskDate = new Date();
    const tz = moment.tz.guess();
    const localDateTime = momentTimezone(taskDate).tz(tz);
    const localDateTimeStartOfDay = localDateTime.startOf('day').toDate();
    const result = rrulestr(task?.repeat?.rule).before(localDateTimeStartOfDay);
    date = result ? new Date(moment(result).toISOString()).toISOString() : date;
    if(task.id == '8651'){
      //console.log('date', result, task?.repeat?.rule, localDateTimeStartOfDay)
    }
  }

  return date;
}

export const dateWithOverdueColor = (date, dateFormat = 'DD MMM YYYY', task = null) => {
  let taskDate = moment(date);
  const today = moment().startOf('day');
  const diff = taskDate.diff(today, 'days');

  // If overdue task
  if(diff < 0 && task){
    taskDate = moment(calcRecentOverDueDate(task));
  }
  
  if (diff === 0) return <span>Today</span>;
  if (diff === 1) return <span>Tomorrow</span>;
  if (diff === -1) return <span className="overdueTaskColor text-overDue">Yesterday</span>;
  
  return <span className={diff < 0 ? 'overdueTaskColor text-overDue' : ''}>
    {taskDate.format(dateFormat)}
  </span>;
}

export const planTimeFormat = ( time ) => {
  return moment.utc(time * 1000).format(time / 3600 >= 1 ? 'HH:mm:ss' : 'mm:ss')
}

export function authentication() {
  if (typeof localStorage.getItem('token') !== 'undefined' && localStorage.getItem('token') !== null)
    return true;
  else
    return false;
};

export function loadScript(id, src, attrs = {}, callback = null){  
  const existingScript = document.getElementById(id);  
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = src;    
    script.id = id;
    Object.keys(attrs).map(attr => {
      script.setAttribute(attr, attrs[attr]);
    });
    document.body.appendChild(script);    
    script.onload = () => { 
      if (callback) 
        callback();
    };
  }  
  if (existingScript && callback) 
    callback();
}

export function hexToRgb(colorPicker) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorPicker);
  return result ? `rgb(${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)} / 10%)` : null;
}

export function setFocusOnTimer(){
  document.querySelector('.timer-custom-time').focus();
}

export const dateToTimeLine = ( myDate, dateFormat = 'MM/DD/YY', timeFormat = 'h:mm A' ) => {
  // ensure the date is displayed with today and yesterday
  return moment( myDate ).calendar( null, {
      // when the date is closer, specify custom values
      lastDay:  `[Yesterday] ${timeFormat}`,
      sameDay:  timeFormat,
      // when the date is further away, use from-now functionality             
      sameElse: function () {
          return dateFormat;
      }
  });
}

export const parseMentionInput = (text) => {
  const projectRegex = /@(\w+)/g;
  const projectMatches = [...text.matchAll(projectRegex)];
  const projects = projectMatches.map((match) => match[1]);
  const title = text.replace(projectRegex, "");
  const result = {
    title,
    project: projects.at(0),
  };

  return result;
}

export const extractMentions = (type, editorRef) => {
  const contentState = editorRef?.current?.[type]?.getEditorState().getCurrentContent();
  const rawContent = convertToRaw(contentState);

  const projectMentions = [];
  let plainTextWithoutMentions = '';

  rawContent.blocks.forEach((block) => {
    let blockText = block.text;
    let resultText = '';
    let currentIndex = 0;
    block.entityRanges.forEach((entityRange) => {
      const entity = rawContent.entityMap[entityRange.key];
      // Project mention
      if (entity?.type === 'mention') {
        resultText += blockText.slice(currentIndex, entityRange.offset);
        currentIndex = entityRange.offset + entityRange.length;
        projectMentions.push(entity.data.mention); 
      }
    });

    // Add remaining text after the last entity
    resultText += blockText.slice(currentIndex);
    plainTextWithoutMentions += resultText + '\n';
  });

  return {projectMentions, plainTextWithoutMentions};
};

export const removeMentionsAndConvertToHTML = (type, editorRef) => {
  let contentState = editorRef?.current?.[type]?.getEditorState().getCurrentContent();
  const rawContent = convertToRaw(contentState);

  // Iterate over all blocks and remove mention entities
  rawContent.blocks.forEach((block, blockIndex) => {
    block.entityRanges
      .sort((a, b) => b.offset - a.offset) // reverse order to avoid offset shift
      .forEach(range => {
        const entity = rawContent.entityMap[range.key];
        if (entity && (entity.type === 'mention' || entity.type === '#mention')) {
          const blockKey = block.key;
          const start = range.offset;
          const end = range.offset + range.length;

          const selection = SelectionState.createEmpty(blockKey).merge({
            anchorOffset: start,
            focusOffset: end,
          });

          contentState = Modifier.removeRange(contentState, selection, 'backward');
        }
      });
  });

  // Now convert to HTML
  const html = stateToHTML(contentState);
  return html;
}

export const getEditorContent = (type, editorRef) => {
  // Convert raw content to HTML
  const htmlContent = stateToHTML(editorRef?.current?.[type]?.getEditorState().getCurrentContent(), {
    blockStyleFn: (block) => {
      return null;
    },
    entityStyleFn: (entity) => {
      const entityType = entity.getType();
      const entityData = entity.getData();
      // Handle links
      if (entityType === 'LINK') {
        const url = entityData.url;
        return {
          element: 'a',
          attributes: { href: url, target: '_blank' }
        };
      }

      return null;
    },
  });

  return hasChildTextNode(htmlContent) ? htmlContent : '';
};

export const verifyRepeatedTaskAsPerTodoist = (task, date, condition) => {
  if(task?.repeat?.rule && task?.repeat?.value && task?.repeat?.value != '1'){
    const result = getRepeatedTask(task, date, true, false, false, 'home');
    return result === null ? false : result?.length == 0;
  }

  return condition;
}

export const verifyRepeatedTask = (task, date, condition, before = false, after = false, count = false) => {
  if(task?.repeat?.rule){
    if(count){
      const result = getRepeatedTask(task, date, before, after, count)
      return result
    }

    return before || after ? getRepeatedTask(task, date, before, after) : getRepeatedTask(task, date, before, after)?.length > 0
  }

  return condition;
}

export const getRepeatedTask = (task, date, before = false, after = false, count = false, currentPage = '') => {
  const taskDate = date ?? new Date();
  const tz = moment.tz.guess();
  const localDateTime = momentTimezone(taskDate).tz(tz);
  const localDateTimeStartOfDay = localDateTime.startOf('day').toDate();
  const localDateTimeEndOfDay = localDateTime.endOf('day').toDate();

  try{
    const rule = changeDtstartWithLocalTimezone(task.repeat.rule, taskDate);

    if(count){
      const result = rrulestr(rule.match(/;COUNT/) ? rule : rule.replace('RRULE:', 'RRULE:COUNT=1;')).count();
      return result;
    }

    if(before){
      if(currentPage === 'home'){
        if((rrulestr(rule).between(localDateTimeStartOfDay, localDateTimeEndOfDay, true)).length > 0){
          const result = rrulestr(rule).before(localDateTimeStartOfDay);
          return result ? [moment(result).toISOString()] : [];
        }  
      }else{
        // If task due date was till past, then don't show any task
        if(((rrulestr(rule).between(localDateTimeStartOfDay, localDateTimeEndOfDay, true)).length > 0
        || (rrulestr(rule).after(localDateTimeStartOfDay))) && rrulestr(rule).before(localDateTimeStartOfDay)){
          const result = rrulestr(rule).after(momentTimezone('2020-01-01').tz(tz).startOf('day').toDate(), true);
          return result ? [moment(result).toISOString()] : [];
        }
      }

      return null;
    }

    if(after){
      if(rrulestr(rule).before(localDateTimeStartOfDay)){
        return [];
      }
      const result = rrulestr(rule).after(localDateTimeStartOfDay);
      return result ? [moment(result).toISOString()] : [];
    }
    
    return rrulestr(rule).between(localDateTimeStartOfDay, localDateTimeEndOfDay, true)
  }catch(e){
    return count ? 0 : []
  }
}

// Change all local datetimes as per current local timezone to handle standard and DST timezones
export const changeDtstartWithLocalTimezone = (ruleString, currentDate) => {
  let rule = ruleString;
  let currentTimezoneUTCTime = '';

  // For negative timezone offset, we need to subtract 1 day from the DTSTART value
  const timezoneOffset = moment(moment(currentDate).endOf('day').toISOString()).utcOffset();
  if(timezoneOffset < 0){
    const t = rule.match(/DTSTART:([0-9A-Z]{1,})/, '$1')
    if(t?.[1]){
      rule = rule.replace(t[1], moment(t[1]).subtract(1, 'day').format('YYYYMMDDTHHmmss') + 'Z')
    }
    currentTimezoneUTCTime = moment(moment(currentDate).endOf('day').add(1, 'second').toISOString()).utc().format('THHmmss') + 'Z';
  }else{
    // For positive timezone offset
    currentTimezoneUTCTime = moment(moment(currentDate).endOf('day').toISOString()).utc().format('THHmmss') + 'Z';
  }

  const rrule = rule?.replace(/\;{0,}$/, '');
  const rruleSet = rrulestr(rrule, {forceset: true})
  const ruleObj = RRule.parseString(rruleSet._rrule.toString());
  const rruleTimezoneUTCTime = moment(ruleObj.dtstart).utc().format('THHmmss') + 'Z';

  return rule.replaceAll(rruleTimezoneUTCTime, currentTimezoneUTCTime);
}

export const isValidDate = (dateString) => {
  const date = new Date(dateString ?? '');
  return date instanceof Date && !isNaN(date);
}

export const generateArcPath = (cx, cy, radius, startAngle, endAngle) => {
  // Convert angles to radians
  const startAngleRad = (startAngle * Math.PI) / 180;
  const endAngleRad = (endAngle * Math.PI) / 180;

  // Calculate start and end points
  const startX = cx + radius * Math.cos(startAngleRad);
  const startY = cy + radius * Math.sin(startAngleRad);
  const endX = cx + radius * Math.cos(endAngleRad);
  const endY = cy + radius * Math.sin(endAngleRad);

  // Determine if the arc is greater than 180 degrees
  const largeArcFlag = (endAngle - startAngle) % 360 > 180 ? "1" : "0";;

  // Create the SVG path using the 'A' (arc) command
  const pathData = [
      `M ${startX} ${startY}`,       // Move to start point
      `A ${radius} ${radius}`,       // Arc command
      `0`,                           // No rotation of the arc
      largeArcFlag,                  // Large arc flag
      `1`,                           // Sweep flag (1 for clockwise)
      `${endX} ${endY}`              // Endpoint of the arc
  ].join(" ");

  return pathData;
}

export const fetchBackgroundImages = async (systemDefault = null) => {
  let response = await getBackgroundImages(systemDefault);
  const images = response?.data?.responseData;

  return images
}

export const highlightText = (text, highlight) => {
  if (!highlight.trim()) {
    return text;
  }
  const regex = new RegExp(`(${highlight})`, 'gi');
  return text.replace(regex, '<span class="highlight">$1</span>');
};

// Check if the text is empty or contains only HTML tags
export const hasChildTextNode = (str, type = null) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = str;
  if(type !== null && (type == 'unordered-list-item' || type == 'ordered-list-item')){
    return true;
  }
  return Array.from(tempDiv.childNodes).some(node => 
    node.nodeType === Node.TEXT_NODE && node.nodeValue.trim().length > 0 ||
    (node.nodeType === Node.ELEMENT_NODE && node.textContent.trim().length > 0)
  );
};

// Parsing function for Todoist text
export const parseTodoistTextToHTML = (text, removeEmptyNodes = false) => {
  if (!text) return '';

  DOMPurify.removeAllHooks(); // Remove all hooks
  if(removeEmptyNodes){
    DOMPurify.addHook('afterSanitizeElements', (node) => {
      if (!hasChildTextNode(node.innerHTML)) {
        node.remove();
      }
    });
  }
  // Allow specific attributes for link tags
  const sanitizedText = DOMPurify.sanitize(text, {
    ALLOWED_ATTR: ['href', 'target', 'rel'] // Specify allowed attributes
  });

  return markdown.render(sanitizedText);
};

// Add this utility function at the top of the file
export const convertUrlsToLinks = (text, removeEmptyNodes = true) => {
  // Check if the text is empty or contains only HTML tags
  if (!text || text.trim() === '<p></p>' || text.trim() === '<p><br></p>' || !hasChildTextNode(text)) return '';
  
  return linkifyHtml(parseTodoistTextToHTML(text, removeEmptyNodes), {target: "_blank"});
};

export const isMac = navigator?.userAgent?.includes('Macintosh') ?? false;

export const verifyShortcut = (shortcut, e) => {

  const keys = [];

  if (e.ctrlKey) keys.push('Ctrl');
  if (e.shiftKey) keys.push('Shift');
  if (e.altKey) keys.push('Alt');
  if (e.metaKey) keys.push('Cmd'); // Cmd on Mac

  const key = e.key;

  // Avoid duplicates and modifier-only keys  
  if (!['Control', 'Shift', 'Alt', 'Meta', 'Ctrl', 'Cmd'].includes(key)) {
      keys.push(key?.length === 1 ? key.toUpperCase() : key);
      
      if(keys.join(' ') === shortcut){
        return true;
      }
  }

  return false;
}


// Simple fuzzy scoring
export const getScore = (str, keyword) => {
  const key = keyword.toLowerCase();
  const s = str.toLowerCase();
  if (s === key) return 0;
  if (s.startsWith(key)) return 1;
  if (s.includes(key)) return 2;
  if (key.includes(s)) return 3;

  return 4;
};

// Levenshtein Distance (basic version)
function levenshtein(a, b) {
  const dp = Array.from({ length: a.length + 1 }, (_, i) =>
    Array.from({ length: b.length + 1 }, (_, j) =>
      i === 0 ? j : j === 0 ? i : 0
    )
  );
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      if (a[i - 1] === b[j - 1]) dp[i][j] = dp[i - 1][j - 1];
      else
        dp[i][j] =
          1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
    }
  }
  return dp[a.length][b.length];
}

export const getKeyboardSymbol = (key, returnKeyIfNotFound = false) => {
  const keySymbols = {
    Control: '⌃',     // Ctrl
    Ctrl: '⌃',
    Shift: '⇧',
    Alt: '⌥',
    Option: '⌥',
    Meta: '⌘',        // Cmd (on Mac)
    Command: '⌘',
    Cmd: '⌘',
    Enter: '⏎',
    Escape: '⎋',
    Esc: '⎋',
    Backspace: '⌫',
    Delete: '⌦',
    Tab: '⇥',
    ArrowUp: '↑',
    ArrowDown: '↓',
    ArrowLeft: '←',
    ArrowRight: '→',
    Space: '␣',
    ' ': '␣'
  };

  return keySymbols?.[key] ?? (returnKeyIfNotFound ? key : '');
};

export const removeHtmlMarkups = (text) => {
  return text.replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim();
};